import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "app-sidebar-vue",
  class: "app-sidebar reduced"
}
const _hoisted_2 = {
  key: 0,
  class: "top-info"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_SidebarSubtitle = _resolveComponent("SidebarSubtitle")!
  const _component_Metadata = _resolveComponent("Metadata")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_NcAppSidebarTab = _resolveComponent("NcAppSidebarTab")!
  const _component_NcAppSidebar = _resolveComponent("NcAppSidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.reducedOpen)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
          (_ctx.info)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.info.basename), 1),
                  _createVNode(_component_NcActions, { inline: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NcActionButton, {
                        "aria-label": _ctx.t('memories', 'Close'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_CloseIcon, { size: 20 })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Close')) + " ", 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_SidebarSubtitle, {
                  size: _ctx.info.size,
                  mtime: _ctx.info.mtime
                }, null, 8, ["size", "mtime"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Metadata, { ref: "metadata" }, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.nativeOpen)
      ? (_openBlock(), _createBlock(_component_NcAppSidebar, {
          key: 1,
          id: "app-sidebar-native",
          open: _ctx.nativeOpen,
          active: _ctx.nativeTab?.id ?? '',
          name: _ctx.nativeNode?.displayname ?? '',
          "no-toggle": "",
          onClose: _ctx.close,
          "onUpdate:active": _ctx.setTab
        }, {
          subname: _withCtx(() => [
            _createVNode(_component_SidebarSubtitle, {
              size: _ctx.info?.size ?? 0,
              mtime: _ctx.info?.mtime ?? 0
            }, null, 8, ["size", "mtime"])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTabs, (tab) => {
              return (_openBlock(), _createBlock(_component_NcAppSidebarTab, {
                key: tab.id,
                id: tab.id,
                name: tab.displayName,
                order: tab.order
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "svg-icon",
                    innerHTML: tab.iconSvgInline
                  }, null, 8, _hoisted_4)
                ]),
                default: _withCtx(() => [
                  (_ctx.readyTabs.has(tab.tagName))
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(tab.tagName), {
                        key: 0,
                        ".active": _ctx.nativeTab?.id === tab.id,
                        ".node": _ctx.nativeNode,
                        ".folder": _ctx.nativeFolder,
                        ".view": _ctx.nativeView
                      }, null, 40, [".active", ".node", ".folder", ".view"]))
                    : (_openBlock(), _createBlock(_component_XLoadingIcon, { key: 1 }))
                ]),
                _: 2
              }, 1032, ["id", "name", "order"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["open", "active", "name", "onClose", "onUpdate:active"]))
      : _createCommentVNode("", true)
  ], 64))
}